import React, { useEffect, useState } from "react";
import _OrderRow from "./_OrderRow";
import { FaSearch } from "react-icons/fa";
import { useAppContext } from "../../../../../../Components/AppProvider";

function _Shipped() {
  const [menuOpenId, setMenuOpenId] = useState(null);
  const [shippedOrder, setShippedOrder] = useState([]);
  const [updateShippedOrder, setUpdateShippedOrder] = useState(false);
  const { setCountListUpdate } = useAppContext();

  // ✅ search state
  const [searchTerm, setSearchTerm] = useState("");

  // ✅ keep track of selected orders
  const [selectedOrders, setSelectedOrders] = useState([]);
  const [expandedId, setExpandedId] = useState(null);
  useEffect(() => {
    let intervalId;

    async function fetchOrderContent() {
      try {
        const res = await fetch(
          `${process.env.REACT_APP_BASE_URL}api/orders/get-shipped-order`,
          { credentials: "include" }
        );

        if (!res.ok) {
          console.error("HTTP error:", res.status);
          return;
        }

        const data = await res.json();
        if (Array.isArray(data.shippedOrder)) {
          setShippedOrder(data.shippedOrder);
          //console.log("data.shippedOrder :", data.shippedOrder);
        } else {
          console.error("Invalid response:", data);
          setShippedOrder([]);
        }
      } catch (err) {
        console.error("Failed to fetch pending orders", err);
        setShippedOrder([]);
      }
    }

    fetchOrderContent(); // run immediately once

    // ⏱️ set interval
    intervalId = setInterval(fetchOrderContent, 10000);

    // 🧹 cleanup when component unmounts or dependency changes
    return () => clearInterval(intervalId);
  }, [updateShippedOrder]);

  // ✅ filter orders based on search term
  const filteredOrders = shippedOrder.filter((order) => {
    const keyword = searchTerm.toLowerCase();

    const displayStatus =
      order.COI_Status === "Paid" ? "FP Paid" : order.COI_Status || "";

    return (
      order.PD_Name?.toLowerCase().includes(keyword) ||
      order.PO_Number?.toLowerCase().includes(keyword) ||
      `${order.CP_Firstname} ${order.CP_Lastname}`
        .toLowerCase()
        .includes(keyword) ||
      displayStatus.toLowerCase().includes(keyword)
    );
  });

  // ✅ handle toggle of one row
  const handleRowSelect = (id) => {
    setSelectedOrders((prev) =>
      prev.includes(id) ? prev.filter((oid) => oid !== id) : [...prev, id]
    );
  };

  // ✅ handle toggle all
  const handleSelectAll = (e) => {
    if (e.target.checked) {
      setSelectedOrders(filteredOrders.map((o) => o.COI_ID));
    } else {
      setSelectedOrders([]);
    }
  };

  // ✅ check if all are selected
  const allSelected =
    filteredOrders.length > 0 &&
    filteredOrders.every((o) => selectedOrders.includes(o.COI_ID));

  const handleUpdateStatus = async (order) => {
    try {
      const ok = window.confirm(
        `Mark ${selectedOrders.length} order as Delivered?`
      );
      if (!ok) return;
      // 1️⃣ Update order status to "Ready to Ship"
      const updateRes = await fetch(
        `${process.env.REACT_APP_BASE_URL}api/orders/update-status`,
        {
          method: "PUT",
          headers: {
            "Content-Type": "application/json",
          },
          body: JSON.stringify({ COI_ID: order.COI_ID, status: "Delivered" }),
        }
      );

      if (!updateRes.ok) {
        throw new Error("Failed to update order status");
      }

      setUpdateShippedOrder((p) => !p);
      setCountListUpdate((prev) => !prev);
      // 3️⃣ Update the transactions state

      alert(`Order #${order.COI_ID} now Delivered ✅`);
    } catch (error) {
      console.error("Error updating order:", error);
      alert("Something went wrong while updating the order.");
    }
  };
  const handleBulkUpdateStatus = async () => {
    try {
      const ok = window.confirm(
        `Mark ${selectedOrders.length} order(s) as Delivered?`
      );
      if (!ok) return;

      const res = await fetch(
        `${process.env.REACT_APP_BASE_URL}api/orders/update-status`,
        {
          method: "PUT",
          headers: { "Content-Type": "application/json" },
          body: JSON.stringify({
            COI_ID: selectedOrders,
            status: "Completed",
          }),
        }
      );

      if (!res.ok) throw new Error("Bulk update failed");

      const data = await res.json();
      alert(data.message);

      setUpdateShippedOrder((p) => !p); // refresh table
      setCountListUpdate((prev) => !prev);
      setSelectedOrders([]); // clear selection
    } catch (err) {
      console.error("Bulk update error:", err);
      alert("Failed to update orders");
    }
  };

  return (
    <main className="ad-order-panel-container">
      <div className="order-panel-header">
        <div className="order-panel-title-wrapper">
          <span>SHIPPED ORDER</span>
        </div>
        <div className="order-panel-actions-wrapper">
          {/* ✅ Only show button when there are selected orders 
          {selectedOrders.length > 0 && (
            <button disabled>
              VIEW ORDER HISTORY ({selectedOrders.length})
            </button>
          )}*/}
          {selectedOrders.length > 0 && (
            <button onClick={handleBulkUpdateStatus}>
              DELIVERED ({selectedOrders.length})
            </button>
          )}

          <div className="order-search-bar">
            <input
              type="text"
              placeholder="Keyword..."
              value={searchTerm}
              onChange={(e) => setSearchTerm(e.target.value)}
            />
            <span>
              <FaSearch />
            </span>
          </div>
        </div>
      </div>

      <div className="order-panel-table-wrapper">
        <table>
          <thead>
            <tr>
              <th></th>
              <th>
                <input
                  type="checkbox"
                  checked={allSelected}
                  onChange={handleSelectAll}
                />
              </th>
              <th></th>
              <th>PRODUCT NAME</th>
              <th>CUSTOMER NAME</th>
              <th>ORDER TYPE</th>
              <th>DATE ORDERED</th>
              <th>UNIT PRICE</th>
              <th>QTY</th>
              <th>DEPOSIT</th>
              <th>BALANCE</th>
              <th>STATUS</th>
              <th></th>
            </tr>
          </thead>
          <tbody>
            {filteredOrders.length > 0 ? (
              filteredOrders.map((order) => (
                <_OrderRow
                  key={order.COI_ID}
                  order={order}
                  menuOpenId={menuOpenId}
                  setMenuOpenId={setMenuOpenId}
                  isSelected={selectedOrders.includes(order.COI_ID)}
                  onSelect={() => handleRowSelect(order.COI_ID)}
                  expandedId={expandedId}
                  setExpandedId={setExpandedId}
                  handleUpdateStatus={handleUpdateStatus}
                />
              ))
            ) : (
              <tr>
                <td
                  colSpan="13"
                  style={{ textAlign: "center", padding: "20px" }}
                >
                  No results found
                </td>
              </tr>
            )}
          </tbody>
        </table>
      </div>
    </main>
  );
}

export default _Shipped;
